// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TO5z","placeholdersHeader":"styles_placeholdersHeader__1BG9f","editorStyle":"styles_editorStyle__fMdgI","placeholdersBox":"styles_placeholdersBox__3SWqe"};